import { ShoppingBag } from "lucide-react";
import { useCart } from "../context/CartContext";

export default function FloatingCart() {
    const { count, setOpen, open } = useCart();
    if (open) return null; // Hide when cart drawer is open
    return (
        <button
            data-testid="floating-cart-btn"
            onClick={() => setOpen(true)}
            className="fixed bottom-24 right-4 sm:bottom-28 sm:right-6 z-40 bg-flagred hover:bg-[#a30d1f] text-white p-3 sm:p-3.5 rounded-full shadow-xl hover:shadow-2xl hover:scale-110 transition-all flex items-center justify-center"
            aria-label="Abrir carrito"
        >
            <ShoppingBag className="w-5 h-5" strokeWidth={2.5} />
            {count > 0 && (
                <span
                    data-testid="floating-cart-count"
                    className="absolute -top-1 -right-1 bg-flaggreen text-white text-[10px] font-bold w-5 h-5 rounded-full flex items-center justify-center shadow border-2 border-white"
                >
                    {count}
                </span>
            )}
        </button>
    );
}
